import { render, staticRenderFns } from "./SystemArguments.vue?vue&type=template&id=2461327f&scoped=true&"
import script from "./SystemArguments.vue?vue&type=script&lang=js&"
export * from "./SystemArguments.vue?vue&type=script&lang=js&"
import style0 from "./SystemArguments.vue?vue&type=style&index=0&id=2461327f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2461327f",
  null
  
)

export default component.exports